import { Link } from "react-router-dom";
import { CONTEXT, ROUTES } from "@/content/routes";
import { cn } from "@/lib/utils";

const FAMILY = ["engine", "stewardship"];

export const ContextNav = ({ group, current }) => {
  const g = CONTEXT[group];
  const item = ([k, label]) => (
    <Link
      key={k}
      to={ROUTES[k].path}
      state={g.via && FAMILY.includes(k) ? { via: g.via } : undefined}
      data-testid={`context-link-${k}`}
      aria-current={k === current ? "page" : undefined}
      className={cn(
        "shrink-0 whitespace-nowrap border-b-2 py-3 text-sm transition-colors",
        k === current ? "border-o-accent text-o-text" : "border-transparent text-o-dim hover:text-o-text"
      )}
    >
      {label}
    </Link>
  );
  return (
    <nav aria-label={`${g.label} sections`} data-testid={`context-nav-${group}`} className="border-b border-o-line">
      <div className="no-scrollbar flex items-center gap-6 overflow-x-auto">
        {g.items.map(item)}
        {g.related && (
          <>
            <span aria-hidden className="h-4 w-px shrink-0 bg-o-strong" />
            <span className="shrink-0 font-mono text-[10px] uppercase tracking-[0.2em] text-o-dim">{g.relatedLabel}</span>
            {g.related.map(item)}
          </>
        )}
      </div>
    </nav>
  );
};
